import _ from "lodash";

import sideNavListing from "constants/side-nav-listing";

import SideNavDto from "dto/components/app-side-nav-dto";

const getSideNavListing = (): SideNavDto[] => {
	const clonedSideNav = _.cloneDeep(sideNavListing) as SideNavDto[];

	const sideNav = clonedSideNav.filter((a: SideNavDto) => {
		return a;
	});

	return sideNav;
};

export default getSideNavListing;
